<template>
  <div ref="root" />
</template>

<script>
export default {
  name: 'XEmbed',
  props: {
    postUrl: {
      type: String,
      required: true
    },
    options: {
      type: Object,
      default: () => ({ dnt: true })
    }
  },
  mounted () {
    this.render()
  },
  methods: {
    getTweetId (u) {
      try {
        const url = new URL(u);
        // supports twitter.com or x.com
        if (!/twitter\.com|x\.com$/.test(url.hostname)) return null
        const m = url.pathname.match(/status\/(\d+)/)
        return m ? m[1] : null
      } catch { 
        return null
      }
    },
    ensureScript () {
      return new Promise((resolve, reject) => {
        if (window.twttr?.widgets) return resolve(window.twttr)

        if (document.getElementById('x-widgets')) {
          const check = () => window.twttr?.widgets ? resolve(window.twttr) : setTimeout(check, 50)
          return check()
        }

        const s = document.createElement('script')
        s.id = 'x-widgets'
        s.src = 'https://platform.twitter.com/widgets.js'
        s.async = true
        s.onload = () => resolve(window.twttr)
        s.onerror = reject
        document.head.appendChild(s)
      })
    },
    async render (clear = false) {
      const id = this.getTweetId(this.postUrl)
      if (!id) return
      if (clear) this.$refs.root.innerHTML = ''

      const twttr = await this.ensureScript()
      await twttr.widgets.createTweet(id, this.$refs.root, this.options)
    }
  }
}
</script>